<template>

     <v-section col="col-md-6">
        <v-alert v-if="error" :message="error" type="danger" />
        <v-alert v-else-if="success" :message="success" type="success" />
        <form @submit.prevent="send">
            <v-form-group label="Name">
                <v-input type="text" placeholder="Your Name" :model="params.name" @input="params.name = $event" />
            </v-form-group>
            <v-form-group label="Email">
                <v-input type="email" placeholder="Your Email" :model="params.email" @input="params.email = $event" />
            </v-form-group>
            <v-form-group label="Company Name">
                <v-input type="text" placeholder="Your Company Name" :model="params.company" @input="params.company = $event" />
            </v-form-group>
            <v-form-group label="Company Website">
                <v-input type="url" placeholder="http://" :model="params.website" @input="params.website = $event" />
            </v-form-group>
            <v-form-group label="Your Message">
                <v-textarea :rows="5" :model="params.note" @input="params.note = $event" />
            </v-form-group>
            <v-button class="float-end" :loading="loading" @click.native="send">
                <span>Send</span>
                <v-loader v-if="loading" class="ml-10" size="sm" type="white" />
            </v-button>
        </form>
    </v-section>

</template>

<script>

import axios from 'axios';

export default {

    data() {
        return {
            loading: false,
            success: null,
            error: null,
            params: {},
        }
    },

    mounted() {
        if (this.$recaptchaInstance) {
            this.$recaptchaInstance.showBadge();
        }
        window.addEventListener('load', () => {
            this.$recaptchaInstance.showBadge();
        });
    },

    beforeDestroy() {
        if (this.$recaptchaInstance) {
            this.$recaptchaInstance.hideBadge();
        }
    },

    methods: {

        async send() {
            this.loading = true;
            await this.$recaptchaLoaded();
            this.params.recaptcha = await this.$recaptcha('login');
            axios.post(process.env.VUE_APP_API_URL + '/v1/inquiry', this.params)
                .then((response) => {
                    this.loading = false;
                    this.success = 'Thanks for your inquiry. We’ll be in touch shortly.';
                    this.error = null;
                    this.params = {};
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                    this.success = null;
                });
        },

    },

}

</script>